export enum Genders {
    MALE = "Male",
    FEMALE = "Female",
    UNKNOWN = "Prefer not to say",
}
